var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUserAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9999,
    cy: 24.5,
    rx: 23.9999,
    ry: 24,
    fill: "#C3CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4545 17.1364C29.4545 20.52 26.7017 23.2727 23.3182 23.2727C19.9346 23.2727 17.1818 20.52 17.1818 17.1364C17.1818 13.7528 19.9346 11 23.3182 11C26.7017 11 29.4545 13.7528 29.4545 17.1364ZM33.1363 35.5455V31.0463C33.1363 27.4369 29.8337 24.5 25.7727 24.5H20.8636C16.8026 24.5 13.5 27.4369 13.5 31.0463V35.5455V36.7727V38H33.1363V36.7727V35.5455Z",
    fill: "#F6F7F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserAdded);
export default __webpack_public_path__ + "static/media/no-user-added.a4e7437221fb9e727d65b416a90dff82.svg";
export { ForwardRef as ReactComponent };